import { useQuery } from "react-query";
import { getBrandsList } from "../api";
import { API_KEY_GET_PROJECTS_LIST } from "../constants";

export const useGetBrandsList = () => {
  return useQuery([API_KEY_GET_PROJECTS_LIST], () => getBrandsList());
};
